angular.module("procedureContratto.components", [])
.component("procedureContratto", {
    templateUrl: "ng/components/monitorPratica/procedureContratto/procedureContratto.view.html",
    bindings: {
        listaProcedure: "<"
    },
    controllerAs: "procedureContrattoCtrl",
    controller: function ProcedureContratto() {
        var self = this;

        self.$onInit = function () {
           console.log(' ')
        };
    }
});